export type AnalyticsConsent = 'unknown' | 'accepted' | 'declined'
const cookieName = 'seaa_analytics_consent'
const lifetimeSeconds = 180 * 86_400
const listeners = new Set<() => void>()
let memory: { value: AnalyticsConsent; expiresAt: number } | undefined

export function analyticsPrivacySignal() {
  return typeof navigator !== 'undefined' && (navigator.doNotTrack === '1'
    || (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl === true)
}
export function readAnalyticsConsent(): AnalyticsConsent {
  if (typeof document === 'undefined') return 'unknown'
  try {
    const value = document.cookie.split(';').map(part => part.trim()).find(part => part.startsWith(`${cookieName}=`))?.slice(cookieName.length + 1)
    if (value === 'accepted' || value === 'declined') return value
  } catch { /* Fall back to this page's explicit choice. */ }
  return memory && memory.expiresAt > Date.now() ? memory.value : 'unknown'
}
export function analyticsAllowed() { return !analyticsPrivacySignal() && readAnalyticsConsent() === 'accepted' }
export function subscribeAnalyticsConsent(listener: () => void) { listeners.add(listener); return () => { listeners.delete(listener) } }
export function clearAnalyticsVisitorCookie() {
  if (typeof document === 'undefined') return
  try { document.cookie = `seaa_public_visitor_day=; Max-Age=0; Path=/; SameSite=Lax${window.location.protocol === 'https:' ? '; Secure' : ''}` } catch { /* Cookie storage may be blocked. */ }
}
export function setAnalyticsConsent(value: Exclude<AnalyticsConsent, 'unknown'>) {
  memory = { value, expiresAt: Date.now() + lifetimeSeconds * 1000 }
  try { document.cookie = `${cookieName}=${value}; Max-Age=${lifetimeSeconds}; Path=/; SameSite=Lax${window.location.protocol === 'https:' ? '; Secure' : ''}` } catch { /* Keep the explicit decision in memory for this page. */ }
  if (value === 'declined' || analyticsPrivacySignal()) clearAnalyticsVisitorCookie()
  listeners.forEach(listener => listener())
}
